/*
 * Layout view for the standard response page, which is a simplified version of the topic page
 */

define([
  "marionette",
  "modules/topicsSplit/standardResponse/template/standardResponseTemplate.html",
], function (Marionette, StandardResponseTemplate) {
  const StandardResponseView = {};

  StandardResponseView.standardResponseLayout = Marionette.Layout.extend({
    template: StandardResponseTemplate,
    regions: {
      header: ".main-header",
      response: "#standardResponseArea",
    },
  });

  return StandardResponseView;
});
